module.exports = __webpack_public_path__ + "img/progress_057.68ca04a8.png";